import { render, staticRenderFns } from "./edit-select-objects.vue?vue&type=template&id=c7f57d34&scoped=true&"
import script from "./edit-select-objects.vue?vue&type=script&lang=js&"
export * from "./edit-select-objects.vue?vue&type=script&lang=js&"
import style0 from "./edit-select-objects.vue?vue&type=style&index=0&id=c7f57d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f57d34",
  null
  
)

export default component.exports